import React from 'react'
import PropTypes from 'prop-types'
import './Item.css'
import history from './history'

const Item = (props) => {
  const wrapperRef = React.useRef(null)

  const textRef = React.useCallback(node => {
    if (node !== null) {
      const itemLinks = node.querySelectorAll('a')

      itemLinks.forEach(itemLink => itemLink.addEventListener('click', handleTextLinkClick))
    }
  })

  const handleTextLinkClick = (e) => {
      e.preventDefault()
      const appOrigin = window.location.origin
      const appHostname = window.location.hostname
      const appPathname = window.location.pathname
      const linkOrigin = e.target.origin
      const linkHostname = e.target.hostname
      const linkPathname = e.target.pathname
      const linkHash = e.target.hash

      if (linkHash && linkHash.length > 0 && (appOrigin + appPathname === linkOrigin + linkPathname)) {
        const hashTargetElement = document.getElementById(linkHash.substr(1))
        hashTargetElement ? hashTargetElement.scrollIntoView({block: 'start', behavior: 'smooth'}) : wrapperRef.current.scrollIntoView({block: 'end', behavior: 'smooth'})
        return
      }

      if (linkHostname === appHostname) {
        const pathname = e.target.pathname
        const nextLocation = {
          pathname
        }

        history.push(nextLocation)

        return
      }

      window.location.href = e.target.href
  }

  return (
    <div className="Item" ref={wrapperRef}>
      <div ref={textRef} dangerouslySetInnerHTML={props.introtext} />
    </div>
  )
}

Item.propTypes = {
  id: PropTypes.number,
  content: PropTypes.string
}

export default Item
